import React from "react";

import div from "../../assets/gif/diversity.gif";
import grow from "../../assets/gif/growth (1).gif";
import reward from "../../assets/gif/winner.gif";
import coll from "../../assets/gif/collaboration.gif";
import emp from "../../assets/gif/respect.gif";

const cards = [
  {
    icon: div,
    title: "Diverse & Inclusive Culture",
  },
  {
    icon: grow,
    title: "Growth Opportunities",
  },
  {
    icon: reward,
    title: "Rewarding Benefits",
  },
  {
    icon: coll,
    title: "Collaboration",
  },
  {
    icon: emp,
    title: "Empowerment & Respect",
  },
];

function BenefitsOfJoiningUs() {
  return (
    <div className="benefits-container">
      <header className="header">
        <h1 className="header-title">Benefits of Joining Us</h1>
        <div className="underline" />
      </header>

      <section className="cards-container">
        {cards.map((card, idx) => (
          <div key={card.title} className="card">
            <div className="front">
              <span className="icon">
                <img
                  src={card.icon}
                  alt={card.title}
                  className="gif-color-change"
                />
              </span>
              <div className="title">{card.title}</div>
            </div>
            <div className="back">
              <span className="icon">
                <img
                  src={card.icon}
                  alt={card.title}
                  className="gif-color-change"
                />
              </span>
              <div className="title">{card.title}</div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}

export default BenefitsOfJoiningUs;
